import { render, staticRenderFns } from "./LicitacaoFornecedorPropostaItem.vue?vue&type=template&id=032d51c1"
import script from "./LicitacaoFornecedorPropostaItem.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorPropostaItem.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorPropostaItem.vue?vue&type=style&index=0&id=032d51c1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports